import { ComponentInstall } from "../../utils";
import DatePicker from "./src";

export default ComponentInstall(DatePicker);
